
import { Options, Vue } from 'vue-class-component';
import RadioButton from '@/common/components/form-ui/radio-button.component.vue';
import { clientModule } from '@/modules/client/client.vuex-module';
import { OrderPayment } from '@/common/models/OrderPayment.model';
import { InjectReactive, Prop, Watch } from 'vue-property-decorator';
import ActiveOrder from '@/modules/order/common/classes/ActiveOrder.class';
import { SquareCard } from '@/common/interfaces/SquareCard.interface';
import RadioButtonGroup from '@/common/components/form-ui/radio-button-group.component.vue';

@Options({
	name: 'CreditCardPaymentMethod',
	components: { RadioButton, RadioButtonGroup },
	emits: ['canSubmit'],
})
export default class CreditCardPaymentMethod extends Vue {
	@InjectReactive() orderPayment!: OrderPayment;
	@InjectReactive() activeOrder!: ActiveOrder;

	selectedCard = 0; // index of selected card

	squareCard!: SquareCard; // square card
	squareConfig = {
		appId: clientModule.location?.PaymentPublicApiKey,
		locationId: clientModule.location?.SquareLocationId,
	};
	get cardOptions() {
		const options = [
			// ...this.orderPayment.CardsOnFile.map((c) => {
			// 	return {
			// 		label: `Card *${c.Last4}`,
			// 		value: c.OrderPaymentKey,
			// 	};
			// }),
			{
				label: 'New Card',
				value: 0,
			},
		];
		return options;
	}

	async created() {
		this.squareCard = await this.initSquareWebPayments()
			.then((card) => {
				return card;
			})
			.finally(() =>
				setTimeout(() => {
					this.$emit('canSubmit', true);
				}, 1000),
			);
	}

	async getSquareToken() {
		try {
			const result = await this.squareCard.tokenize();

			// Square tokenization can return a non-null token even when the card data
			// is invalid. Checking the status prevents sending a bad nonce to the API
			// which would result in an INVALID_CARD_DATA error from Square.
			if (result.status !== 'OK') {
				console.error('[ERROR] Square tokenization failed:', result.status, result.errors);
				return null;
			}

			return result.token;
		} catch {
			console.error('[ERROR] Could not get square token');
			return null;
		}
	}

	async initSquareWebPayments() {
		const payments = (window as any).Square.payments(this.squareConfig.appId, this.squareConfig.locationId);
		const card = await payments.card({
			style: {
				// View limited Square styling selectors https://tinyurl.com/39htzet5
				input: {
					fontSize: '14px',
				},
			},
		});

		return await card.attach('#card-container').then(() => {
			return card;
		});
	}
}
